import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from '../../contexts/ToastContext';
import { logout } from '../../services/otpAuthService';
import { alFineSessioneDipendente } from '../../services/fineSessioneDipendente';
import { MESSAGGIO_SESSIONE_FINITA } from '../../utils/sessioneAssociato';

/**
 * Ascoltatore globale (App) per il dipendente dello studio (Ruling R15/R16).
 * - Sessione finita (401 `DIPENDENTI_SPENTI`/`SESSIONE_NON_VALIDA`, da REST o GraphQL): logout completo
 *   come per il token scaduto, toast e pagina di accesso (con la pagina di provenienza, come
 *   AssociatePrivateRoute).
 * - Studio non in regola (403): nessun logout; da una sezione dell'area riservata si torna alla
 *   dashboard, che mostra l'avviso. Fuori dall'area riservata la pagina resta.
 * Il titolare non arriva mai qui (fineSessioneDipendente filtra sulla sessione del dipendente).
 */
const FineSessioneDipendente: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const posizione = useRef(location);
  posizione.current = location;
  const toastRef = useRef(toast);
  toastRef.current = toast;

  useEffect(
    () =>
      alFineSessioneDipendente((motivo) => {
        const { pathname, search } = posizione.current;
        if (motivo === 'sessione') {
          logout();
          toastRef.current.error(MESSAGGIO_SESSIONE_FINITA);
          navigate('/accesso-associati', { replace: true, state: { from: pathname + search } });
          return;
        }
        if (pathname.startsWith('/area-riservata/')) navigate('/area-riservata', { replace: true });
      }),
    [navigate]
  );

  return null;
};

export default FineSessioneDipendente;
